import { Button } from '@wyz/ui';
import { useFormContext } from 'react-hook-form';
import { Trans } from '~/common/context';
import { WcwSearchHelpers } from '~/purchase/helpers';
import { IWcwFilter } from '~/purchase/types';

type WcwFilterForm = IWcwFilter & { sort: string };

const WcwFilterResetButton = () => {
  const { reset } = useFormContext<WcwFilterForm>();

  return (
    <Button
      id='reset-filters-button'
      variant='link'
      size='sm'
      onClick={() =>
        reset({
          ...WcwSearchHelpers.WCW_FILTER_DEFAULT,
          sort: WcwSearchHelpers.WCW_LIST_STATE_DEFAULT.sort,
        })
      }
    >
      <Trans i18nKey='app.common.clear_all' />
    </Button>
  );
};

export default WcwFilterResetButton;
